import { render, staticRenderFns } from "./PaginaAdminUsuariosInstitucion.vue?vue&type=template&id=c0ed9f38&lang=es"
import script from "./PaginaAdminUsuariosInstitucion.vue?vue&type=script&lang=js"
export * from "./PaginaAdminUsuariosInstitucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports